import * as React from "react"

// 744px = ProERP-eigener `tablet`-Breakpoint (siehe globals.css) statt Tailwinds
// Standard-`md` (768px) — muss damit übereinstimmen, sonst rendert die Sidebar
// hier ihre Sheet-Variante (isMobile=true), obwohl der äußere `AppSidebar`-Wrapper
// (apps/web, `hidden tablet:flex`) sie längst sichtbar geschaltet hat.
const MOBILE_BREAKPOINT = 744

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined)

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    }
    mql.addEventListener("change", onChange)
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    return () => mql.removeEventListener("change", onChange)
  }, [])

  return !!isMobile
}

// Ab hier legt sich die Seitenleiste nicht mehr als Overlay über den Inhalt,
// sondern steht fest daneben. Darunter (iPad im Hochformat, schmale Fenster)
// würde sie breiten Tabellen den Platz nehmen — Entscheidung Tech-Lead,
// Qualitäts-Audit 2026-09-28. Telefone (< 744 px) nutzen ohnehin die MobileDock.
export const SIDEBAR_OVERLAY_BREAKPOINT = 1024

/**
 * true, solange die Seitenleiste als Overlay (Sheet) läuft. Startwert sofort aus
 * der Fensterbreite — sonst zeigte das iPad beim Laden kurz die feste Leiste.
 */
export function useIsSidebarOverlay() {
  const [isOverlay, setIsOverlay] = React.useState<boolean>(
    () => typeof window !== "undefined" && window.innerWidth < SIDEBAR_OVERLAY_BREAKPOINT
  )

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${SIDEBAR_OVERLAY_BREAKPOINT - 1}px)`)
    const onChange = () => setIsOverlay(window.innerWidth < SIDEBAR_OVERLAY_BREAKPOINT)
    mql.addEventListener("change", onChange)
    onChange()
    return () => mql.removeEventListener("change", onChange)
  }, [])

  return isOverlay
}
